function actualizarHora() {
    // Obtener la fecha y hora actual del dispositivo
    const ahora = new Date();
    
    // Obtener horas, minutos y segundos (con dos dígitos)
    const horas = ahora.getHours().toString().padStart(2, '0');
    const minutos = ahora.getMinutes().toString().padStart(2, '0');
    
    // Formato: HH:MM:SS (puedes cambiar a HH:MM si no quieres segundos)
    const horaFormateada = `${horas}:${minutos}`;
    
    // Insertar la hora en el párrafo
    document.getElementById('hora-local').textContent = horaFormateada;
}

// Llamar a la función inmediatamente para que no tarde 1 segundo en aparecer
actualizarHora();

// Actualizar cada segundo (1000 ms)
setInterval(actualizarHora, 60000);